/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, message, Modal} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import './invoice.css';
import {sKeylist} from '../../service/dictionary/dataitem';
import {
    invoiceTempTotalAmount,
    setProductUp1,
    newPurchaseUnit,
    setProductUp3,
    exportFun,
    textZan
} from '../../service/invoiceManagement';
import {Store, Actions} from './store';
import {objectSerial, config} from 'Utils';
import {fetchChannelList} from "../../service/home";

class invoiceApply extends Reflux.Component {
    dmsIcon = {
        fontFamily: 'dmsIcon!important'
    };

    constructor(props) {
        super(props);
        const d = new Date();
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.defaultIndex = '';
        this.defaultOrgId = null;
        this.defaultOrgType = null;
        this.defaultDate = d.format('yyyy-MM-dd');
        this.state = {
            opts: ['开票申请'],
            key: 0,
            visible: false,
            selectedRowKeys: [],
            selectedRows: [],
            rows: [],
            total: 1,
            channel_rank: [],
            channel_type: [],
            buy: [],
            searchObj: {
                name: '',
                category: [],
                active: '',
                // startDate: d.format('yyyy-MM-dd'),
                // endDate: d.format('yyyy-MM-dd'),
                crStartDate: '',
                crEndDate: '',
                orderStartDate: '',
                orderEndDate: '',
                saleType: '',
                channel: '',
                s: 10,
                p: 1,
                taxCode: '',
            },
            categoryData: [],
            button_limits_end: {},
            paramsToApply: {},
            loading: true,
            channelList: []
        };
        this.pageChange = this.pageChange.bind(this);
        this.addChange = this.addChange.bind(this);
        this.importChange = this.importChange.bind(this);
        this.specifiedChange = this.specifiedChange.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    /*选择*/
    onSelectChange = (selectedRowKeys, selectedRows) => {

        var selectitems = this.state.selectedRows;

        var items = [];

        selectedRows.forEach((key, i) => {

            var flag = true;

            selectitems.forEach((k, z) => {
                if (k.lineId == selectedRows[i].lineId) {
                    flag = false;
                    return;
                }
            })
            if (flag) {
                selectitems.push(selectedRows[i]);
            }
        });

        selectitems.forEach((key, i) => {
            if (selectedRowKeys.indexOf(key.lineId) >= 0) {
                items.push(selectitems[i]);
            }
        });


        var selectAmount = 0;

        for (var i = 0; i < items.length; i++) {
            selectAmount = selectAmount + items[i].totalAmount;
        }

        var selectQty = 0;

        for (var i = 0; i < items.length; i++) {
            selectQty = selectQty + items[i].qty;
        }

        this.setState({selectedRowKeys, selectedRows: items});
        this.setState({seletedCount: selectedRowKeys.length, selectAmount: selectAmount, selectQty: selectQty});
    };
    /*筛选*/
    // setFilterParam(name, value) {
    //     this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    // };
    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    crStartDate: value.from,
                    crEndDate: value.end,
                }
            })
        } else if (name === 'orderTime2') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderStartDate: value.from,
                    orderEndDate: value.end,
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*加到暂存单*/
    addChange() {
        let self = this;
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        /*if (!this.state.abc) {
            openNotice('warning', '请查询购货单位');
            return;
        }*/
        // console.log(self.state.abc)

        let params = self.state.selectedRowKeys;

        /*textZan(self.state.abc).then( result => {
            console.log(result);
            if (result.code == 400) {
                openNotice('warning', '请选择购货单位',(result && result.message) ? result.message : '');
            };
            if (result.code == 200) {*/
        setProductUp3(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '添加成功', '');
                self.initData();
            } else {
                openNotice('error', '添加失败', (result && result.message) ? result.message : '');
            }
        });
        /*}
    })*/


        // debugger
        // console.log(params);


    };

    /*Excel导入开票*/
    importChange() {
        console.log("Excel导入开票")

    };

    /*指定金额开票*/
    specifiedChange = () => {
        this.setState({
            visible: true,
        });
    };
    handleOk = (e) => {
        // console.log(e);
        this.setState({
            visible: false,
        });
    };
    handleCancel = (e) => {
        // console.log(e);
        this.setState({
            visible: false,
        });
    };

    /*导出*/
    exportChange() {
        const {rows, total, selectedRows} = this.state;
        if (!rows.length && !total) {
            message.warning('当前没有数据可以导出。请查询后再做操作。');
        } else if (selectedRows.length > 500) {
            message.warning('请不要勾选超过500行');
        } else {
            if (!selectedRows.length) {
                openNotice('warning', '请选择订单');
                return;
            }
            let _arr = selectedRows.map(x => {
                // console.log(x);
                return x.lineId;
            });
            let _obj = _arr.join('&lineIds=');
            // console.log(_obj);
            Modal.confirm({
                title: '操作提示',
                content: '确定导出当前条件的数据吗?',
                onOk() {
                    // window.location.href = `${exportFun}?${objectSerial({...searchObj, s: total, endDate: searchObj.endDate+' 23:59:59'})}&exPortType=0&exPortIds=`
                    // let xxx = `${exportFun}?${objectSerial({...searchObj, s: total, endDate: searchObj.endDate+' 23:59:59'})}&exPortType=0&exPortIds=`
                    window.location.href = `${config.server}/api/v1/dms/tzOrderSync/exportInvoiceInfo?lineIds=${_obj}`;
                },
                onCancel() {
                },
            });
        }
    };

    /* 直接开票 */
    directInvoice() {
        // console.log(this.state.selectedRows);
        const {selectedRows} = this.state;
        if (!selectedRows.length) {
            openNotice('warning', '请选择产品');
            return;
        }
        let unitId = selectedRows[0].salesUnitId,
            unitChannelCode = selectedRows[0].salesChannelCode,
            unitTaxCode = selectedRows[0].taxCode,
            list = [];
        for (var i = 0; i < selectedRows.length; i++) {
            if (selectedRows[i].salesUnitId != unitId) {
                openNotice('warning', '请选择相同的购货单位');
                return;
            }
            if (selectedRows[i].salesChannelCode != unitChannelCode) {
                openNotice('warning', '请选择相同的渠道');
                return;
            }
            if (selectedRows[i].taxCode != unitTaxCode) {
                openNotice('warning', '请选择相同的税码');
                return;
            }
            list.push({
                // deliveryId: selectedRows[i].deliveryId,
                // orderNumber: selectedRows[i].orderNumber,
                // itemNum: selectedRows[i].itemNum
                lineId: selectedRows[i].lineId
            });
        }
        ;
        // console.log(list);
        /*let list = selectedRows.map(x => {
            return {
                deliveryId: x.deliveryId,
                orderNumber: x.orderNumber,
                itemNum: x.itemNum
            }
        });*/
        this.goView({
            pathname: 'invoiceManagement/normalInvoice',
            state: {
                type: 'direct',
                list
            }
        });
    }

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            // channel_rank: [],
            // channel_type: [],
            // bug: [],
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                orderTime: '',
                crStartDate: '',
                crEndDate: '',
                deliveryId: '',
                channel: '',
                orderNumber: '',
                salesUnitName: '',
                orderTime2: '',
                orderStartDate: '',
                orderEndDate: '',
                saleType: '',
                lineId: '',
                taxCode: '',
            }
        }, function () {
            self.initData();
            this.setState({selectedRowKeys: []});
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({abc: this.state.searchObj.salesUnitName})

        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1,
            }
        }, function () {
            self.initData();

            this.setState({selectedRowKeys: []});
        });
    };

    /* 翻页 刷新 */
    pageChange(page, pageSize) {
        let self = this;
        self.setState({
            searchObj: {
                ...self.state.searchObj,
                s: pageSize,
                p: page
            }
        }, function () {
            self.initData();
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        let channelList = self.state.channelList;
        self.setState({
            'loading': true
        });
        var channelData = window.sessionStorage.getItem('cur_channelId') || '{}';
        newPurchaseUnit(channelData).then(res => { //物料类别
            if (res.status) {
                // debugger
                // console.log(res)
                var arr = new Array();
                // for (var i = 0; i <= res.length ; i ++ ) {
                //   arr[i].name=res[i].name,
                //     arr[i].id=res[i].id
                // }
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                });
                self.setState({buy: arr})
            }
        });
        let searchObj = self.state.searchObj;
        searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        searchObj.deliveryIdList = self.state.paramsToApply.deliveryIdList;
        searchObj.orderNumberList = self.state.paramsToApply.orderNumberList;
        searchObj.salesChannelCodeList = self.state.paramsToApply.salesChannelCodeList;
        searchObj.salesUnitIdList = self.state.paramsToApply.salesUnitIdList;
        searchObj.lineRemarkList = self.state.paramsToApply.lineRemarkList;
        /*searchObj.p = 1;
        searchObj.s = 10;*/
        setProductUp1(searchObj).then(function (result) {
            if (result && result.code == 200) {

                var arr = new Array();
                for (var x = 0; x < result.data.length; x++) {
                    channelList.map(itm => {
                        if (itm.code == result.data[x].salesChannelCode) {
                            result.data[x].salesChannelName = itm.name;
                        }
                    });
                    arr.push(result.data[x]);  // 用循环逐个把值保存在新数组内
                }

                for (var i = 0; i < arr.length; i++) {
                    arr[i].id = result.data[i].lineId;
                }

                self.setState({
                    'rows': arr || [],
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
            // debugger
            // console.log(self.state.rows)
        });

    };

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentDidMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        sKeylist({sKey: 'INVOICE_ORDER_TYPE'}).then(res => { //渠道类型
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                });
                self.setState({channel_rank: arr})
            }
            fetchChannelList().then(result => {
                if (result && result.code == 200 && result.status == true) {
                    this.setState({channelList: result.data}, () => {
                        this.initData();
                    })
                }
            });
            //设置离开当前路由时的钩子函数
            this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        })

        invoiceTempTotalAmount().then(res => {
            if (res && res.code == 200) {
                self.setState({
                    'tempTotal': res.data.total || 0
                });
            }
        })


        // 废除的渠道(数据字典)
        //  sKeylist({sKey: 'INVOICE_CHANNEL_TYPE'}).then(res => { //渠道类型
        //   if(res.status){
        // 	let arr = [
        // 	  {
        // 		text: '全部',
        // 		value: ''
        // 	  }
        // 	];
        // 	res.data.forEach(x => {
        // 	  arr.push({
        // 		text: x.name,
        // 		value: x.sKey
        // 	  })
        // 	});

        // 		self.setState({channel_type: arr})

        //   }
        // })
        let _channel = JSON.parse(window.sessionStorage.getItem('channel_list'))
            , arr = []
        ;
        // console.log(_channel);
        _channel.shift();
        _channel.map(x => {
            arr.push({
                text: x.name,
                value: x.code
            })
        });
        self.setState({channel_type: arr})
        // getProductCategory().then(function (categoryResult) {
        // 	/* 产品分类 */
        // 	if (!categoryResult || categoryResult.code != 200) {
        // 		openNotice('error', '产品分类数据获取失败，请重试', '');
        // 		return;
        // 	}
        // 	self.setState({
        // 		categoryData: categoryResult.data || []
        // 	});
        // });
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            paramsToApply: JSON.parse(localStorage.getItem('paramsToApply'))
        });
    }

    selectOnChange(value) {
        console.log(value);

    }

    // componentDidMount () {
    // 	this.initData();
    // 	//设置离开当前路由时的钩子函数
    // 	this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    // }

    render() {
        const {
            opts,
            paramsToApply,
            key,
            rows,
            total,
            searchObj,
            selectedRowKeys,
            channel_rank,
            channel_type,
            button_limits_end,
            buy,
            loading
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'itemNum',
                    label: '物料编号',
                    text: '输入物料编号',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '出库日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.crStartDate || '',
                        end: searchObj.crEndDate || ''
                    },
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                },
                {
                    name: 'channel',
                    label: '渠道',
                    text: '选择状态',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.channel || ''
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                }, {
                    name: 'custPoNumber',
                    label: '要货单号',
                    text: '输入要货单号',
                    type: 'default',
                    defaultValue: searchObj.custPoNumber
                },
                {
                    name: 'salesUnitName',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    require: true,
                    onChange: this.selectOnChange.bind(this),
                    options: buy,
                    defaultValue: searchObj.salesUnitName
                },
                {
                    name: 'orderTime2',//startCreatedDate, endCreatedDate
                    label: '下单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderStartDate || '',
                        end: searchObj.orderEndDate || ''
                    },
                },
                {
                    name: 'saleType',
                    label: '发运类型',
                    text: '选择发运类型',
                    options: channel_rank,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.saleType || ''
                },
                {
                    name: 'lineId',
                    label: '发票池ID',
                    text: '输入发票池ID',
                    type: 'default',
                    defaultValue: searchObj.lineId
                },
                {
                    name: 'taxCode',
                    label: '税号',
                    text: '选择税号',
                    options: [
                        {text: '16', value: 16},
                        {text: '17', value: 17},
                        {text: '13', value: 13}
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.taxCode || ''
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        // debugger
        // console.log(rows)

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'lineId',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber',
                    // render: (text, record, index) => {
                    // 	return (
                    // 		<a href={`#/invoiceManagement/${record.id}`}>{text}</a>
                    // 	)
                    // }
                },
                {
                    title: '要货单号',
                    dataIndex: 'custPoNumber'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '下单日期',
                    dataIndex: 'orderDate',
                    render: (text, record, index) => {
                        return text.split(' ')[0];
                    }
                },
                {
                    title: '出库日期',
                    dataIndex: 'crDate',
                    render: (text, record, index) => {
                        return text.split(' ')[0];
                    }
                },
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName'
                },
                {
                    title: '渠道',
                    dataIndex: 'salesChannelName'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '物料类别',
                    dataIndex: 'itemCategory'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '数量',
                    dataIndex: 'qty'
                },
                {
                    title: '单价(元)',
                    dataIndex: 'price'
                },
                {
                    title: '金额',
                    dataIndex: 'totalAmount'
                },
                {
                    title: '发运类型',
                    dataIndex: 'saleType'
                },
                {
                    title: '头备注',
                    dataIndex: 'remark'
                },
                {
                    title: '行备注',
                    dataIndex: 'lineRemark'
                },
                {
                    title: '发票池ID',
                    dataIndex: 'lineId'
                },
            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange
            }
        };
        const iconLayout = {
            fontSize: '32px'
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button key="back"
                        onClick={this.goView.bind(this, `/invoiceManagement/invoiceApplyStart`)}>返回</Button>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {button_limits_end.invoiceApply_list_03 &&
                        <a className="dms-table-a"
                           onClick={this.goView.bind(this, `/invoiceManagement/invoiceStaging`)}>
                            <i className="anticon anticon-exception" style={iconLayout}></i>&nbsp;&nbsp;&nbsp;
                            <span className="stagingCount">{this.state.tempTotal}</span>
                        </a>}
                    <span>已选{this.state.seletedCount || 0}条，总金额：{this.state.selectAmount || 0}元，总数量：{this.state.selectQty || 0}</span>
                    {
                        button_limits_end.invoiceApply_list_01
                        &&
                        <Button style={{position: 'absolute', bottom: 8, right: 90}}
                                onClick={this.addChange}>加到暂存单</Button>
                    }
                    {
                        button_limits_end.invoiceApply_list_02
                        &&
                        <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                                onClick={this.exportChange}>导出</Button>
                    }
                    {
                        button_limits_end.invoiceApply_list_03
                        &&
                        <Button style={{position: 'absolute', bottom: 8, right: 202}}
                                onClick={this.directInvoice.bind(this)}>直接开票</Button>
                    }
                    {/*
					{ button_limits_end.invoiceApply_list_02 && <Button style={{position:'absolute', bottom:8, right:208}} onClick={this.importChange}>Excel导入开票</Button>}
				   	{ button_limits_end.invoiceApply_list_03 &&  <Button style={{position:'absolute', bottom:8, right:86}} onClick={this.specifiedChange}>指定金额开票</Button>}
					
					*/}
                </div>
                <TableView {...tableViewProps}/>
            </div>
            <div>
                <Modal
                    title="指定金额开票"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <p>Some contents...</p>
                    <p>Some contents...</p>
                    <p>Some contents...</p>
                </Modal>
            </div>
        </div>
    }
}

export default withRouter(invoiceApply);


// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/invoiceApply.js